import { fetchAdminV1, fetchTenantAdminV1, fetchV1 } from "../lib/requester/v1";
import { ROLES } from "../helpers/constants";

// Helper function to determine which API endpoint to use based on user role
const getApiEndpoint = (user) => {
  if (user?.roles?.includes(ROLES.SUPERADMIN)) {
    return fetchAdminV1;
  } else if (user?.roles?.includes(ROLES.TENANT_ADMIN)) {
    return fetchTenantAdminV1;
  }
  return fetchAdminV1; // Default fallback
};

export function getMatchedOpportunityWithUserAnswers(matchId) {
	return fetchV1(`/matches/${matchId}/opportunity/answers`, { method: "GET" });
}

export function getMatchedCampaignWithUserAnswers(matchId) {
	return fetchV1(`/matches/${matchId}/campaign/answers`, { method: "GET" });
}

export function getRecommendedCampaignsForOpportunityForAdmin(id) {
	return fetchAdminV1(`/matches/recommend/campaign/opportunity?id=${id}`, { method: "GET" });
}

export function getMatchByParams(params) {
	return fetchV1(`/matches`, { method: "GET", data: params });
}

export function create(data) {
	return fetchAdminV1("/matches", { method: "POST", data });
}

export function updateAction(data) {
	return fetchV1(`/matches/${data.id}/action`, { method: "PUT", data });
}

export function updateSchedule(data) {
	return fetchV1(`/matches/${data.id}/schedule`, { method: "PUT", data }, { returnWholeError: true });
}

export function acceptSchedule(data) {
	return fetchV1(`/matches/${data.id}/schedule/accept`, { method: "PUT", data }, { returnWholeError: true });
}

export function getFounderVendorMatchesAdmin({ page = 1, limit = 10 } = {}) {
	return fetchAdminV1(`/matches/founder-vendor-matches?page=${page}&limit=${limit}`,
		{ method: 'GET' });
}

// ===== FOUNDER-FUNDER MATCHES API FUNCTIONS =====

export function getFounderFunderMatchesAdmin(filters = {}, { page = 1, limit = 20 } = {}, user = null) {
	console.log('🔍 [DEBUG] Frontend API: getFounderFunderMatchesAdmin called with:', { filters, page, limit, userRole: user?.roles });
	
	const queryParams = new URLSearchParams();
	
	// Add pagination
	queryParams.append('page', page.toString());
	queryParams.append('limit', limit.toString());
	
	// Add filters
	Object.entries(filters).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== '') {
			queryParams.append(key, value.toString());
		}
	});
	
	const url = `/matches/founder-funder-matches?${queryParams.toString()}`;
	console.log('🔍 [DEBUG] Frontend API: Making request to:', url);
	
	const apiEndpoint = getApiEndpoint(user);
	console.log('🔍 [DEBUG] Frontend API: Using endpoint:', apiEndpoint === fetchAdminV1 ? 'Admin' : 'TenantAdmin');
	
	return apiEndpoint(url, { method: 'GET' })
		.then(response => {
			console.log('🔍 [DEBUG] Frontend API: Response received:', response);
			console.log('🔍 [DEBUG] Frontend API: Response type:', typeof response);
			console.log('🔍 [DEBUG] Frontend API: Response keys:', response ? Object.keys(response) : 'No response');
			return response;
		})
		.catch(error => {
			console.error('🔍 [DEBUG] Frontend API: Error occurred:', error);
			throw error;
		});
}

export function getFounderFunderMatchStatsAdmin(user = null) {
	console.log('🔍 [DEBUG] Frontend API: getFounderFunderMatchStatsAdmin called with user:', user?.roles);
	
	const apiEndpoint = getApiEndpoint(user);
	console.log('🔍 [DEBUG] Frontend API: Using endpoint for stats:', apiEndpoint === fetchAdminV1 ? 'Admin' : 'TenantAdmin');
	
	return apiEndpoint('/matches/founder-funder-matches/stats', { method: 'GET' })
		.then(response => {
			console.log('🔍 [DEBUG] Frontend API: Stats response received:', response);
			return response;
		})
		.catch(error => {
			console.error('🔍 [DEBUG] Frontend API: Stats error occurred:', error);
			throw error;
		});
}

export function getFounderFunderMatchByIdAdmin(id, user = null) {
	const apiEndpoint = getApiEndpoint(user);
	return apiEndpoint(`/matches/founder-funder-matches/${id}`, { method: 'GET' });
}

export function updateFounderFunderMatchAdmin(id, updateData, user = null) {
	const apiEndpoint = getApiEndpoint(user);
	return apiEndpoint(`/matches/founder-funder-matches/${id}`, { 
		method: 'PUT', 
		data: updateData 
	});
}

export function addInvestmentDetailsAdmin(id, investmentData, user = null) {
	const apiEndpoint = getApiEndpoint(user);
	return apiEndpoint(`/matches/founder-funder-matches/${id}/investment`, { 
		method: 'PUT', 
		data: investmentData 
	});
}

export function trackCommunicationAdmin(id, user = null) {
	const apiEndpoint = getApiEndpoint(user);
	return apiEndpoint(`/matches/founder-funder-matches/${id}/communication`, { 
		method: 'POST' 
	});
}

export function createFounderFunderMatchAdmin(matchData, user = null) {
	const apiEndpoint = getApiEndpoint(user);
	return apiEndpoint('/matches/founder-funder-matches', { 
		method: 'POST', 
		data: matchData 
	});
}
